<template>
  <Layout>
    <div class="is-size-7 p-md">
      <form class="pure-form preview" method="GET" action="http://tb.premium-advertiser.com/gg-bg/">
      <div class="has-text-centered" style="margin:auto;max-width:600px;">
        <GameTile :game="game" class="has-text-left" />
        <p class="is-size-5 has-text-primary">Game Game - най-добрият портал за фитнес и хранене!</p>
          <p class="is-size-5 has-text-white">ВЪВЕДЕТЕ МОБИЛЕН НОМЕР:</p>
          <div class="m-md">
            <input type="hidden" name="msisdn" :value="msisdnWithPrefix">
            <input type="text" v-model="msisdn" class="input is-primary m-r-md is-size-3" style="width:100%;">
            <span v-if="!hasValidMsisdn || !checked" class="button is-dark is-size-3">Плати с мобилния оператор</span>
            <input v-else class="button is-primary is-size-3 m-t-sm" @click="isMsisdn = false" type="submit" value="Плати с мобилния оператор" />
          </div>
        <div class="is-size-5 checkbox" >
          <input type="checkbox" v-model="checked">Съгласявам се с общите условия.
        </div>
        <p class="is-size-7 m-t-lg m-b-lg">
          Цената е 6.01 лв. за месец
        </p>
      </div>
      </form>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/GG'
import GameTile from '@/components/LangGG/GameTile'


export default {
  name: 'Home',
  components: {
    Layout,
    GameTile
  },
  data () {
    return {
      checked: false,
      msisdn: '0',
      carrier: '23001',
      game: {
        name: 'Speed Pool King',
        path: 'https://assets.gamega.me/avi/SpeedPoolKing_0304/index.html',
        icon: 'https://assets.gamega.me/avi/SpeedPoolKing_0304/sqricon.png',
        tags: [ 'Ability', 'Action', 'Maximum score' ],
        votes: 29,
        score: 3.7241379310344827,
        id: 111
      }
    }
  },
  computed: {
    hasValidMsisdn () {
      return this.msisdn.match(/^(00359|0|\+359|359)?([1-9][0-9]+)/) instanceof Array
    },
    msisdnWithPrefix () {
      return this.msisdn.split(' ').join('').replace(/^(00359|0|\+359|359)?([1-9][0-9]+)/, '00359$2')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LangGG/BG/LPDcb.vue